import React, { useState, useEffect, useContext } from "react";

import RouterContext from "../../context/RouterContext";
import "../../App.css";
import {updateSedute} from "./Utils";
import {properties} from "../../utils/properties";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';

export default function MeetingListAll() {
    var dateStyle = {
        display: "flex",
        paddingLeft: "40px",        
    };

    const [meetingData, setMeetingData] = useState([]);
    const { pageRouter, setPageRouter } = useContext(RouterContext);    
    const navigate = useNavigate();

    const isInTheFuture = function(dateOfInterest) {      
        const date = new Date();
        let day = date.getDate();
        if(day<10) 
            day="0"+day;
        let month = date.getMonth() + 1;
        if(month<10) 
            month="0"+month;
        let year = date.getFullYear();
        let today= year+""+month+""+day;        
        let meetingDate= dateOfInterest.substring(4, 8)+dateOfInterest.substring(2, 4)+dateOfInterest.substring(0, 2);
        //console.log("VERIFICA DATE:", today, meetingDate, today < meetingDate);
        if (today < meetingDate)
            return "New";
        else    
            return undefined;
    }

    const updateUI = function(jsonData) {     
        if( properties.verboseLog==1)
            console.log("UPDATEUI-LV");
        var entireMeeting = Object.entries(jsonData);                    
        var orderMeeting = [];
        var colore='#30720f';
        for (var i = entireMeeting.length - 1; i >= 0; i--) {
            //"Entrambi", "Tetrambi","ConsColl","ComiColl"
            if(entireMeeting[i][1]["organo"]==="Entrambi"){
                var eachMeeting = {
                    id: entireMeeting[i][0],
                    order: entireMeeting[i][1]["order"],
                    date: entireMeeting[i][1]["dataSeduta"],
                    organo: "Comitato",                    
                    nuovo: isInTheFuture(entireMeeting[i][0]),
                    otherId: entireMeeting[i][0].substring(4, 8)+
                    entireMeeting[i][0].substring(2, 4)+
                    entireMeeting[i][0].substring(0, 2),
                    color: '#30720f'
                };        
                orderMeeting.push(eachMeeting);
                var eachMeeting2 = {
                    id: entireMeeting[i][0],
                    order: entireMeeting[i][1]["order"],
                    date: entireMeeting[i][1]["dataSeduta"],
                    organo: "Consiglio",            
                    nuovo: isInTheFuture(entireMeeting[i][0]),
                    otherId: entireMeeting[i][0].substring(4, 8)+
                    entireMeeting[i][0].substring(2, 4)+
                    entireMeeting[i][0].substring(0, 2),
                    color: '#BF360C'
                };        
                orderMeeting.push(eachMeeting2);
            }
            if(entireMeeting[i][1]["organo"]==="ComiColl"){
                var eachMeeting = {
                    id: entireMeeting[i][0],
                    order: entireMeeting[i][1]["order"],
                    date: entireMeeting[i][1]["dataSeduta"],
                    organo: "Comitato",                    
                    nuovo: isInTheFuture(entireMeeting[i][0]),
                    otherId: entireMeeting[i][0].substring(4, 8)+
                    entireMeeting[i][0].substring(2, 4)+
                    entireMeeting[i][0].substring(0, 2),
                    color: '#30720f'
                };        
                orderMeeting.push(eachMeeting);
                var eachMeeting2 = {
                    id: entireMeeting[i][0],
                    order: entireMeeting[i][1]["order"],
                    date: entireMeeting[i][1]["dataSeduta"],
                    organo: "Collegio",                    
                    nuovo: isInTheFuture(entireMeeting[i][0]),
                    otherId: entireMeeting[i][0].substring(4, 8)+
                    entireMeeting[i][0].substring(2, 4)+
                    entireMeeting[i][0].substring(0, 2),
                    color: '#666999'
                };        
                orderMeeting.push(eachMeeting2);
            }
            if(entireMeeting[i][1]["organo"]==="ConsColl"){                                
                var eachMeeting2 = {
                    id: entireMeeting[i][0],
                    order: entireMeeting[i][1]["order"],
                    date: entireMeeting[i][1]["dataSeduta"],
                    organo: "Consiglio",                    
                    nuovo: isInTheFuture(entireMeeting[i][0]),
                    otherId: entireMeeting[i][0].substring(4, 8)+
                    entireMeeting[i][0].substring(2, 4)+
                    entireMeeting[i][0].substring(0, 2),
                    color: '#BF360C'
                };        
                orderMeeting.push(eachMeeting2);
                var eachMeeting = {
                    id: entireMeeting[i][0],
                    order: entireMeeting[i][1]["order"],
                    date: entireMeeting[i][1]["dataSeduta"],
                    organo: "Collegio",                    
                    nuovo: isInTheFuture(entireMeeting[i][0]),
                    otherId: entireMeeting[i][0].substring(4, 8)+
                    entireMeeting[i][0].substring(2, 4)+
                    entireMeeting[i][0].substring(0, 2),
                    color: '#666999'
                };      
                orderMeeting.push(eachMeeting);  
            }
            if(entireMeeting[i][1]["organo"]==="Tetrambi"){
                var eachMeeting = {
                    id: entireMeeting[i][0],
                    order: entireMeeting[i][1]["order"],
                    date: entireMeeting[i][1]["dataSeduta"],
                    organo: "Comitato",                    
                    nuovo: isInTheFuture(entireMeeting[i][0]),
                    otherId: entireMeeting[i][0].substring(4, 8)+
                    entireMeeting[i][0].substring(2, 4)+
                    entireMeeting[i][0].substring(0, 2),
                    color: '#30720f'
                };        
                orderMeeting.push(eachMeeting);
                var eachMeeting2 = {
                    id: entireMeeting[i][0],
                    order: entireMeeting[i][1]["order"],
                    date: entireMeeting[i][1]["dataSeduta"],
                    organo: "Consiglio",                    
                    nuovo: isInTheFuture(entireMeeting[i][0]),
                    otherId: entireMeeting[i][0].substring(4, 8)+
                    entireMeeting[i][0].substring(2, 4)+
                    entireMeeting[i][0].substring(0, 2),
                    color: '#BF360C'
                };        
                orderMeeting.push(eachMeeting2);
                var eachMeeting3 = {
                    id: entireMeeting[i][0],
                    order: entireMeeting[i][1]["order"],
                    date: entireMeeting[i][1]["dataSeduta"],
                    organo: "Collegio",                 
                    nuovo: isInTheFuture(entireMeeting[i][0]),
                    otherId: entireMeeting[i][0].substring(4, 8)+
                    entireMeeting[i][0].substring(2, 4)+
                    entireMeeting[i][0].substring(0, 2),
                    color: '#666999'
                };        
                orderMeeting.push(eachMeeting3);
            }
            
            if(entireMeeting[i][1]["organo"]==="Consiglio"){
                colore='#BF360C';                            
                var eachMeeting = {
                    id: entireMeeting[i][0],                    
                    order: entireMeeting[i][1]["order"],                
                    date: entireMeeting[i][1]["dataSeduta"],                
                    organo: entireMeeting[i][1]["organo"],                    
                    nuovo: isInTheFuture(entireMeeting[i][0]),
                    otherId: entireMeeting[i][0].substring(4, 8)+
                    entireMeeting[i][0].substring(2, 4)+
                    entireMeeting[i][0].substring(0, 2),
                    color: colore
                };        
                orderMeeting.push(eachMeeting);
            }
            if(entireMeeting[i][1]["organo"]==="Comitato"||entireMeeting[i][1]["organo"]== undefined){                            
                colore='#30720f';        
                var eachMeeting = {
                    id: entireMeeting[i][0],                    
                    order: entireMeeting[i][1]["order"],                
                    date: entireMeeting[i][1]["dataSeduta"],                
                    organo: entireMeeting[i][1]["organo"],                    
                    nuovo: isInTheFuture(entireMeeting[i][0]),
                    otherId: entireMeeting[i][0].substring(4, 8)+
                    entireMeeting[i][0].substring(2, 4)+
                    entireMeeting[i][0].substring(0, 2),
                    color: colore
                };
                orderMeeting.push(eachMeeting);
            }
            if(entireMeeting[i][1]["organo"]==="Collegio" ){                            
                colore='#666999';        
                var eachMeeting = {
                    id: entireMeeting[i][0],                    
                    order: entireMeeting[i][1]["order"],                
                    date: entireMeeting[i][1]["dataSeduta"],                
                    organo: entireMeeting[i][1]["organo"],                    
                    nuovo: isInTheFuture(entireMeeting[i][0]),
                    otherId: entireMeeting[i][0].substring(4, 8)+
                    entireMeeting[i][0].substring(2, 4)+
                    entireMeeting[i][0].substring(0, 2),
                    color: colore
                };
                orderMeeting.push(eachMeeting);
            }
        }  
        //orderMeeting.sort((a, b) => a.order > b.order ? 1 : -1)
        orderMeeting.sort((a, b) => a.otherId < b.otherId ? 1 : -1)
        setMeetingData(orderMeeting);
    }


    //6
    const doPostSedute6 = function(jsonList) {
        if( properties.verboseLog==1)
            console.log("doing sedute post 6");        

        var xhr2 = new XMLHttpRequest();                
        
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/checkSeduteJsonCollegio.php',true);
        xhr2.withCredentials = true;
        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
        xhr2.onload = function (e) {      
            if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {                              
                    //console.log("OK92",xhr2);
                    var responseText = xhr2.responseText;                    
                    var obj=JSON.parse(responseText);
                    if( properties.verboseLog==1)
                        console.log("OK93",obj, obj.status);          
                    if(obj.status==="204" ){                             
                        console.log("OK MEETINGLISTALL-6 204",xhr2);   
                        var mergedObject =undefined;                     
                        var jsonListSedute = JSON.parse(localStorage.getItem("listSeduteCollegio"));
                        if( properties.verboseLog==1)
                            console.log("BRUT",jsonListSedute,jsonList);
                        if(jsonListSedute!=undefined && jsonListSedute!=null &&jsonListSedute!=""){                          
                            if( properties.verboseLog==1)
                                console.log("2COL",jsonListSedute, "33COL", jsonList);                        
                            
                            var uno=Object.entries(jsonList);
                            var die=Object.entries(jsonListSedute);
                            for(var i = 0, l = die.length; i < l; i++) {                               
                               if(die[i][1].order==0)
                               die[i][1].nuovo ="New";   
                            }
                            for(var i = 0, l = uno.length; i < l; i++) {                                
                                if(uno[i][1].order==0)
                               uno[i][1].nuovo ="New";   
                            }
                            if( properties.verboseLog==1){
                                console.log("UnoUnoCOL",uno);
                                console.log("DueUnoCOL",die);
                            }
                            
                            for(var i = 0, l = die.length; i < l; i++) {
                                for(var j = 0, ll = uno.length; j < ll; j++) {                        
                                    if(die[i][1].dataSeduta === uno[j][1].dataSeduta) {
                                        //console.log("found2");
                                        if((uno[j][1]).organo=="Entrambi")
                                            die[i][1].organo="Tetrambi";
                                        if((uno[j][1]).organo=="Consiglio")
                                            die[i][1].organo="ConsColl";
                                        if((uno[j][1]).organo==undefined)
                                            die[i][1].organo="ComiColl";
                                        //die[i][1].organo="Entrambi";
                                        if(uno[j][1].nuovo=="New")
                                            die[i][1].nuovo="New";
                                    }                                   
                                }
                            }
                            jsonListSedute=Object.fromEntries(die);
                            jsonList=Object.fromEntries(uno);
                            if( properties.verboseLog==1)
                                console.log("PUS UNO COL",jsonListSedute);
                                                                                
                            mergedObject = {
                                ...jsonList,
                                ...jsonListSedute
                              };
                            if( properties.verboseLog==1)
                                console.log("212-COL",mergedObject);
                        }
                        else    
                            mergedObject= jsonList;
                        if( properties.verboseLog==1)
                            console.log("our coll",mergedObject);
                        
                        updateUI(mergedObject);
                    }              
                    else{
                        //status 201
                        console.log("OK MEETINGLISTALL-6 201",xhr2);  
                        
                        try{
                            localStorage.setItem("listSeduteCollegio", obj.content);
                            localStorage.setItem("listSeduteVersionCollegio", obj.date);                                      
                        }
                        catch(error) {
                            console.log("LOCALSTORAGE ISSUE", error);
                        }  
                        
                        var jsonListSedute2 = JSON.parse(obj.content);
                        var mergedObject=undefined;
                        if( properties.verboseLog==1)
                            console.log("AQUI2",jsonListSedute2,jsonList);
                        if(jsonListSedute2!=undefined && jsonListSedute2!=null &&jsonListSedute2!=""){                            
                            var uno=Object.entries(jsonList);
                            var die=Object.entries(jsonListSedute2);
                            if( properties.verboseLog==1){
                                console.log("Uno-",uno);
                                console.log("Due-",die);
                            }
                            for(var i = 0, l = die.length; i < l; i++) {
                                //console.log("Due-------",die[i][1]);
                                if(die[i][1].order == 0)
                                    die[i][1].nuovo = "New";                                    
                            }
                            for(var i = 0, l = uno.length; i < l; i++) {                                
                                if(uno[i][1].order == 0)
                                    uno[i][1].nuovo = "New";    
                            }
                            if( properties.verboseLog==1){                            
                                console.log("Uno",uno);
                                console.log("Due",die);
                            }
                            for(var i = 0, l = die.length; i < l; i++) {
                                for(var j = 0, ll = uno.length; j < ll; j++) {
                                    if( properties.verboseLog==1)
                                        console.log("CHECK2", die[i] , uno[j]);
                                    if(die[i][1].dataSeduta === uno[j][1].dataSeduta) {
                                        if( properties.verboseLog==1)
                                           console.log("found2");
                                        //die[i][1].organo="Entrambi";                                                                                   
                                        if((uno[j][1]).organo=="Entrambi")
                                            die[i][1].organo="Tetrambi";
                                        if((uno[j][1]).organo=="Consiglio")
                                            die[i][1].organo="ConsColl";
                                        if((uno[j][1]).organo==undefined)
                                            die[i][1].organo="ComiColl";                                
                                        if(uno[j][1].nuovo=="New")
                                            die[i][1].nuovo="New";                                        
                                    }                                   
                                }
                            }
                            jsonListSedute2=Object.fromEntries(die);                            
                            jsonList=Object.fromEntries(uno);
                            if( properties.verboseLog==1)
                                console.log("PUS-COL",jsonListSedute2);
                            
                            mergedObject = {
                                ...jsonList,
                                ...jsonListSedute2
                              }; 
                            if( properties.verboseLog==1)  
                                console.log("412-COL",mergedObject);
                        }                            
                        else                                
                            mergedObject=jsonList;
                        if( properties.verboseLog==1)
                            console.log("our coll",mergedObject);                        
                        updateUI(mergedObject);
                    }
                } 
                else {
                    //console.error("Error 1", xhr.statusText);          
                    //alert("Errore recuperando la lista sedute");  
                    var mergedObject=undefined;
                    console.log("Errore 235: Recuperando la lista sedute o non presenti sedute per il ruolo dell'utente");  
                    if(jsonList!=undefined && jsonList!=null &&jsonList!=""){                       
                        mergedObject = jsonList;
                        if( properties.verboseLog==1)
                            console.log("413 COL",mergedObject);
                    }                        
                    else    
                        mergedObject=null;
                    if( properties.verboseLog==1)
                        console.log("our coll 2",mergedObject);
                    
                    updateUI(mergedObject);
                }
            }
        };

        xhr2.onerror = function (e) {
            console.error("Error 22", xhr2.statusText);
        };
        
        let urlEncodedData = null; //"idf=" + meetingId;
        if (localStorage.listSeduteCollegio!=='' &&localStorage.listSeduteCollegio!==undefined){            
            if( properties.verboseLog==1)
                console.log( "QUINDI00");
            const currentData=localStorage.getItem("listSeduteVersionCollegio");        
            urlEncodedData = "date=" + currentData;                    
        }       
        if( properties.verboseLog==1)
            console.log("CVIEW",urlEncodedData);
        xhr2.send(urlEncodedData);
    }
    //6


    //4
    const doPostSedute4 = function(jsonList) {
            if( properties.verboseLog==1)
                console.log("doing sedute post 4");        

            var xhr2 = new XMLHttpRequest();                
            xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/checkSeduteJsonConsiglio.php',true);
            xhr2.withCredentials = true;        
            xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
            xhr2.onload = function (e) {      
                if (xhr2.readyState === 4) {
                    if (xhr2.status === 200) {                              
                        if( properties.verboseLog==1)
                            console.log("OK92",xhr2);
                        var responseText = xhr2.responseText;                    
                        var obj=JSON.parse(responseText);
                        if( properties.verboseLog==1)
                            console.log("OK93",obj, obj.status);          
                        if(obj.status==="204" ){                             
                            console.log("OK MEETINGLISTALL4 204",xhr2);   
                            var mergedObject =undefined;                     
                            var jsonListSedute = JSON.parse(localStorage.getItem("listSeduteConsiglio"));
                            if( properties.verboseLog==1)
                                console.log("AQUI",jsonListSedute,jsonList);
                            if(jsonListSedute!=undefined && jsonListSedute!=null &&jsonListSedute!=""){                          
                                if( properties.verboseLog==1)
                                    console.log("2",jsonListSedute, "33", jsonList);                                
                                
                                var uno=Object.entries(jsonList);
                                var die=Object.entries(jsonListSedute);
                                for(var i = 0, l = die.length; i < l; i++) {                               
                                   if(die[i][1].order==0)
                                   die[i][1].nuovo ="New";   
                                }
                                for(var i = 0, l = uno.length; i < l; i++) {                                
                                    if(uno[i][1].order==0)
                                   uno[i][1].nuovo ="New";   
                                }
                                if( properties.verboseLog==1){
                                    console.log("UnoUno",uno);
                                    console.log("DueUno",die);
                                }
                                if( properties.verboseLog==1)
                                    console.log("3looking3",uno.length,die.length);
                                for(var i = 0, l = die.length; i < l; i++) {
                                    for(var j = 0, ll = uno.length; j < ll; j++) {                                        
                                        if( properties.verboseLog==1)
                                            console.log("CHECK2", die[i] , uno[j]);
                                        if(die[i][1].dataSeduta === uno[j][1].dataSeduta) {
                                            if( properties.verboseLog==1)
                                                console.log("found2");
                                            die[i][1].organo="Entrambi";
                                            if(uno[j][1].nuovo=="New")
                                                die[i][1].nuovo="New";
                                        }                                   
                                    }
                                }
                                jsonListSedute=Object.fromEntries(die);
                                jsonList=Object.fromEntries(uno);
                                if( properties.verboseLog==1)
                                    console.log("PUS UNO",jsonListSedute);
                                                                                    
                                mergedObject = {
                                    ...jsonList,
                                    ...jsonListSedute
                                  };
                                if( properties.verboseLog==1)
                                    console.log("212",mergedObject);
                            }
                            else    
                                mergedObject= jsonList;
                            if( properties.verboseLog==1)
                                console.log("our1",mergedObject);
                            if(localStorage.getItem("ruolo")=="12" ||localStorage.getItem("ruolo")=="21")
                                doPostSedute6(mergedObject);
                            else
                                updateUI(mergedObject);                            
                        }              
                        else{
                            //status 201
                            console.log("OK MEETINGLISTALL-4 201",xhr2);  
                            
                            try{
                                localStorage.setItem("listSeduteConsiglio", obj.content);
                                localStorage.setItem("listSeduteVersionConsiglio", obj.date);                                      
                            }
                            catch(error) {
                                console.log("LOCALSTORAGE ISSUE", error);
                            }  
                            
                            var jsonListSedute2 = JSON.parse(obj.content);
                            var mergedObject=undefined;
                            if( properties.verboseLog==1)
                                console.log("AQUI2",jsonListSedute2,jsonList);
                            if(jsonListSedute2!=undefined && jsonListSedute2!=null &&jsonListSedute2!=""){                            
                                var uno=Object.entries(jsonList);
                                var die=Object.entries(jsonListSedute2);
                                if( properties.verboseLog==1){
                                    console.log("Uno-",uno);
                                    console.log("Due-",die);
                                }
                                for(var i = 0, l = die.length; i < l; i++) {
                                    if( properties.verboseLog==1)
                                        console.log("Due-------",die[i][1]);
                                    if(die[i][1].order == 0)
                                        die[i][1].nuovo = "New";                                    
                                }
                                for(var i = 0, l = uno.length; i < l; i++) {                                
                                    if(uno[i][1].order == 0)
                                        uno[i][1].nuovo = "New";    
                                }       
                                if( properties.verboseLog==1){                     
                                    console.log("Uno",uno);
                                    console.log("Due",die);       
                                }                     
                                for(var i = 0, l = die.length; i < l; i++) {
                                    for(var j = 0, ll = uno.length; j < ll; j++) {
                                        if( properties.verboseLog==1)
                                            console.log("CHECK2", die[i] , uno[j]);
                                        if(die[i][1].dataSeduta === uno[j][1].dataSeduta) {
                                            if( properties.verboseLog==1)
                                                console.log("found2");
                                            die[i][1].organo="Entrambi";                                                                              
                                        }                                   
                                    }
                                }
                                jsonListSedute2=Object.fromEntries(die);                            
                                jsonList=Object.fromEntries(uno);
                                if( properties.verboseLog==1)
                                    console.log("PUS",jsonListSedute2);
                                
                                mergedObject = {
                                    ...jsonList,
                                    ...jsonListSedute2
                                  }; 
                                if( properties.verboseLog==1)
                                    console.log("412",mergedObject);
                            }                                
                            else                                    
                                mergedObject=jsonList;
                            if( properties.verboseLog==1)
                                console.log("our2",mergedObject);                    
                            if(localStorage.getItem("ruolo")=="12" ||localStorage.getItem("ruolo")=="21")
                                doPostSedute6(mergedObject);
                            else    
                                updateUI(mergedObject);                            
                        }
                    } 
                    else {
                        //console.error("Error 1", xhr.statusText);          
                        //alert("Errore recuperando la lista sedute");  
                        var mergedObject=undefined;
                        console.log("Errore 2: Recuperando la lista sedute o non presenti sedute per il ruolo dell'utente");  
                        if(jsonList!=undefined && jsonList!=null &&jsonList!=""){                       
                            mergedObject = jsonList;
                            if( properties.verboseLog==1)
                                console.log("413",mergedObject);
                        }                        
                        else                                
                            mergedObject=null;
                        if( properties.verboseLog==1)
                            console.log("our3",mergedObject);                        
                        if(localStorage.getItem("ruolo")=="12" ||localStorage.getItem("ruolo")=="21")
                            doPostSedute6(mergedObject);
                        else
                            updateUI(mergedObject);
                    }
                }
            };

            xhr2.onerror = function (e) {
                console.error("Error 22", xhr2.statusText);
            };
            
            let urlEncodedData = null; //"idf=" + meetingId;
            if (localStorage.listSeduteConsiglio!=='' &&localStorage.listSeduteConsiglio!==undefined){            
                if( properties.verboseLog==1)
                    console.log( "QUINDI00");
                const currentData=localStorage.getItem("listSeduteVersionConsiglio");        
                urlEncodedData = "date=" + currentData;                    
            }       
            if( properties.verboseLog==1)
                console.log("CIEW",urlEncodedData);
            xhr2.send(urlEncodedData);
    }
    //4

    const doPostSedute2 = function() {
        if( properties.verboseLog==1)
            console.log("doing sedute post LV");
        var xhr2 = new XMLHttpRequest();                        
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/checkSeduteJson.php',true);
        xhr2.withCredentials = true;
        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
        xhr2.onload = function (e) {      
            if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {                              
                    if( properties.verboseLog==1)
                        console.log("OK DOPOSTSEDUTE",xhr2);
                    var responseText = xhr2.responseText;                    
                    var obj=JSON.parse(responseText);
                    if( properties.verboseLog==1)
                        console.log("OK93",obj);          
                    if(obj.status==="204" ){ 
                        console.log("OK MEETINGLISTALL-2 204",xhr2);
                        const jsonListSedute = JSON.parse(localStorage.getItem("listSedute"));                        
                        doPostSedute4(jsonListSedute);
                    }              
                    else{
                        //status 201
                        console.log("OK MMETINGLISTALL-2 201",xhr2);                            
                        try{
                            localStorage.setItem("listSedute", obj.content);
                            localStorage.setItem("listSeduteVersion", obj.date);                                                                                                                                           
                        }
                        catch(error) {
                            console.log("LOCALSTORAGE ISSUE", error);
                        }  
                        
                        const jsonListSedute = JSON.parse(obj.content);                        
                         doPostSedute4(jsonListSedute);
                    }
                } 
                else {                      
                    window.alert("Errore recuperando la seduta");  
                    doPostSedute4(null);
                }
            }
        };

        xhr2.onerror = function (e) {
            console.error("Error 22", xhr2.statusText);
        };
        
        let urlEncodedData = null; //"idf=" + meetingId;
        if (localStorage.listSedute!=='' &&localStorage.listSedute!==undefined){            
            if( properties.verboseLog==1)
                console.log( "QUINDI00");
            const currentData=localStorage.getItem("listSeduteVersion");        
            urlEncodedData = "date=" + currentData;                    
        }            
        xhr2.send(urlEncodedData);
    }

    useEffect(() => {     
        if( properties.verboseLog==1){
            console.log("USEEFFECT CV");
            console.log("Arrivo qui", document.referrer);   
        }
        if(localStorage.getItem("new_ui")==="true"){         
                navigate("/calendarAll");
        }          
                                
        if(!window.cordova){
            
        //CHECK AUTHENTICATION
            var xhr = new XMLHttpRequest();                            
            xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/ping.php',true);
            xhr.withCredentials = true;
            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    
            xhr.onload = function (e) {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {       
                        if( properties.verboseLog==1)                               
                            console.log("OK",xhr);                                                
                        updateSedute("Entrambi",doPostSedute2, updateUI);
                } else {
                    console.error("Error 1", xhr);     
                    localStorage.clear();               
                    if( properties.verboseLog==1)
                        console.log("QWERTY 1",localStorage.getItem("name"));
              
                    navigate("/login");
                }
            }
            };
    
            xhr.onerror = function (e) {
                console.error("Error 2", xhr);                                
                localStorage.clear();       
                if( properties.verboseLog==1)
                    console.log("QWERTY 2",localStorage.getItem("name"));                
                navigate("/login");
            };
             
            let urlEncodedData = null; 
            xhr.send(urlEncodedData);
        //CHECK AUTHENTICATION
        }
        
        if (window.cordova){
            updateSedute("All",doPostSedute2, updateUI);    
        }
                         
    }, []);



    const topicList = (item) => {        
        if(item.organo==='Consiglio'){         
            navigate("/consiglio/"+item.id);
        }        
        else{            
            if(item.organo==='Collegio'){             
                navigate("/collegio/"+item.id);
            }        
            else{                            
                navigate("/fascicoli/"+item.id); 
            }
        }        
    };


    return (
        <div className="content">
       
            {meetingData.map((item, index) => (
                <div key={uuidv4()} className="scheda-item" style={{ borderRightColor: item.color,  }} > 
                <div
                    className="common-list"
                    key={index}
                    style={{
                                cursor: "pointer",
                            }}
                    onClick={() => topicList(item)}
                >
                           <div className="meetingall-row" style={{cursor: "pointer"}}>
                        <p className= "textBlackSedute">
                        Seduta del {item.date}
                        </p>
                        {item.organo==="Consiglio" ?(
                        <p className="textDataSedute meetingall-organo"> Consiglio Generale </p>
                        ):[item.organo==="Collegio" ?(
                            <p className="textDataSedute meetingall-organo"> Collegio Sindacale </p>
                        ): (
                            <p className="textDataSedute meetingall-organo"> Comitato di Gestione </p>
                        )
                    ]}
                      
                    </div>
                    <div
                        style={{
                            paddingRight: "25px",
                            color: "#879497",
                            display: "flex",
                        }}
                    >
                        {item.nuovo == 'New' ? (
                            <div>
                                {item.organo==="Consiglio" ?(
                                    <div
                                    className="meetingall-badge"
                                    style={{
                                        //background: "#ff5a60",
                                        //background: "#30720f",
                                        background: item.color,
                                        color: "white",
                                        borderRadius: "30px",
                                    }}
                                >Nuova </div>
                                    ):(
                                        <div
                                        className="meetingall-badge"
                                        style={{
                                            //background: "#ff5a60",
                                            //background: "#30720f",
                                            background: item.color,
                                            color: "white",
                                            borderRadius: "30px",
                                        }}
                                    >Nuova </div>
                                )}

                            </div>
                        ) : (
                            <></>
                        )}
                        
                        <KeyboardArrowRightIcon sx={{ color: '#879497' }} fontSize="large"/>
                    </div>
                </div>
                </div>
            ))}
        </div>
    );
}
